const PERSON_ATTRIBUTES = {
  account_holder: '',
  account_iban: '',
  bank_bic: '',
  birth_city: '',
  birth_country: '',
  birth_name: '',
  birth_state: '',
  birth_insee_code: [],
  civility: '',
  date_of_birth: '',
  email: '',
  first_name: '',
  home_address: '',
  home_country: '',
  home_phone_number: '',
  last_name: '',
  marital_status: '',
  matrimonial_regime: '',
  mobile_phone_number: '',
  nationalities: [],
  other_names: '',
  pacs_convention: '',
  person_kind: '',
  profession: '',
  profession_sector: '',
  reference_tax_number: '',
  residence_permit_number: '',
  unicia_person_id: '',
  risk_score: '',
  tax_address: '',
  tax_country: '',
  bank_country: '',
  home_address_line_1: '',
  home_address_line_2: '',
  home_address_line_3: '',
  home_insee_code: '',
  home_city: '',
  home_state: '',
  tax_address_line_1: '',
  tax_address_line_2: '',
  tax_address_line_3: '',
  tax_insee_code: '',
  tax_city: '',
  tax_state: '',
  birth_postal_code: '',
  home_postal_code: '',
  tax_postal_code: '',
  user_consent: '',
  relations: {
    jsonApi: 'hasMany',
    type: 'relation',
  },
  person_attached_to: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
  attached_persons: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
  supporting_documents: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
  person_controls: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
  customer_files: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
}

const PERSON_CONTROL_ATTRIBUTES = {
  id: null,
  type: null,
  status: null,
  checks: {},
  person: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
  customer_file: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
}

const CUSTOMER_FILE = {
  id: null,
  type: null,
  amundi_client_reference: null,
  status: null,
  client_type: null,
  creation_type: null,
  completion_rate: null,
  risk_score: null,
  reminders_sent: null,
  last_reminder_sent_at: null,
  user_final_validation_at: null,
  advisor_final_validation_at: null,
  status_last_changed_at: null,
  last_sync_at: null,
  first_reminder_sent_at: null,
  second_reminder_sent_at: null,
  third_reminder_sent_at: null,
  created_at: null,
  gdpr_status: null,
  person_controls: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
  predecessor: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
  unicia_requests: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
}

const CONFIG_MODEL = {
  enums: {},
  person_kind_configurations: [],
}

const DOCUMENT_MODEL = {
  active: null,
  created_at: '',
  document_kind: '',
  expiration_date: '',
  status: '',
  updated_at: '',
  pages: {
    jsonApi: 'hasMany',
    type: 'supporting_document_pages',
  },
  person: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
}

const DOCUMENT_PAGE_MODEL = {
  name: null,
  content_type: '',
  byte_size: '',
  created_at: '',
}

const TIMELINE_MODEL = {
  id: null,
  timeline: [],
}

const GENERIC_MODEL = {}

export {
  CUSTOMER_FILE,
  PERSON_ATTRIBUTES,
  PERSON_CONTROL_ATTRIBUTES,
  GENERIC_MODEL,
  CONFIG_MODEL,
  DOCUMENT_MODEL,
  DOCUMENT_PAGE_MODEL,
  TIMELINE_MODEL,
}
